.customer-organization-form__region-selection__input {
  width: 360px;
}
